import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-road p-mr-3" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-road p-mr-3" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!

  return (_openBlock(), _createBlock(_component_FloatLabel, { label: "Search Work Request" }, {
    default: _withCtx(() => [
      _createVNode(_component_AutoComplete, _mergeProps({
        ref: "shiftAutocomplete",
        dropdown: "",
        completeOnFocus: ""
      }, _ctx.$attrs, {
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
        suggestions: _ctx.suggestions,
        field: _ctx.selectedLabel,
        onKeyup: _withKeys(_ctx.onEnterClick, ["enter"]),
        onComplete: _ctx.search,
        onItemSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelect($event.value)))
      }), {
        chip: _withCtx(({item}) => [
          _createElementVNode("div", {
            title: _ctx.getTitle(item)
          }, [
            _hoisted_2,
            _createElementVNode("span", null, [
              _createElementVNode("b", null, "#" + _toDisplayString(item.id), 1),
              _hoisted_3
            ]),
            _createElementVNode("span", null, _toDisplayString(item.code), 1)
          ], 8, _hoisted_1)
        ]),
        item: _withCtx(({item}) => [
          _createElementVNode("div", {
            title: _ctx.getTitle(item)
          }, [
            _hoisted_5,
            _createElementVNode("span", null, [
              _createElementVNode("b", null, "#" + _toDisplayString(item.id), 1),
              _hoisted_6
            ]),
            _createElementVNode("span", null, _toDisplayString(item.code), 1)
          ], 8, _hoisted_4)
        ]),
        _: 1
      }, 16, ["modelValue", "suggestions", "field", "onKeyup", "onComplete"])
    ]),
    _: 1
  }))
}